var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn rounded bg-main text-white font-bold focus:ring-0 hover:bg-hoverMain",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" "+_vm._s(_vm.$t('goBack'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }